import React from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import OrcaSecurityShiftLeftCredentialsForm from "./OrcaSecurityShiftLeftCredentialsForm";
import { CellRenderers, columnRenderArrayData } from "utils/tableUtils";
import OrcaSecurityShiftLeftMappingForm from "./OrcaSecurityShiftLeftMappingForm";
import { isEmpty } from "lodash";
import { useFeatureFlag } from "contexts/FeatureFlagContext";

export default function OrcaSecurityShiftLeftConfigListing(props) {

  const featureFlags = useFeatureFlag();
  const columns = [
    {
      title: "Project",
      dataIndex: "projectName",
      width: 200,
      render: CellRenderers.VALUE_OR_NA,
    },
    {
      title: "Repository",
      dataIndex: "repositories",
      render: columnRenderArrayData,
      width: 200,
    },
    ...(featureFlags.ORCA_SECURITY_SHIFTLEFT_BRANCH_DISABLED ? [] : [
    {
      title: "Branch",
      dataIndex: "branch",
      render: CellRenderers.VALUE_OR_NA,
      width: 150,
    }
    ]),
    {
      title: "Scan Type",
      dataIndex: "scanTypes",
      width: 150,
      render: (scanTypes, record) =>
        CellRenderers.TAGS(isEmpty(scanTypes) ? "All" : scanTypes.split(",")),
    },
  ];

  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={OrcaSecurityShiftLeftMappingForm}
      CredentialsForm={OrcaSecurityShiftLeftCredentialsForm}
      triggerModifyParam={triggerModifyParam}
      extraColumns={columns}
    />
  );
}

const triggerModifyParam = (record) => {
  return {
      toolConfigId: record.id
  }
}
